import React from "react";

import BackgroundImage from "../../images/sebraeNaDf.jpg";
import transitions from '@material-ui/core/styles/transitions';

import { makeStyles, fade } from '@material-ui/core/styles';

const useStyle = makeStyles((theme) => ({
	gridLabelDocumentos: {
		fontSize: 16,
		fontWeight: 500,
		color: '#5e6784'
	},
	gridNomeArquivo: {
		fontSize: 16,
		lineHeight: 1.38,
		color: '#061243'
	},
	gridNomeArquivoDetalhe: {
		fontSize: 12,
		color: '#5e6784'
	},
	gridTamanho: {
		fontSize: 16,
		color: '#5e6784'
	}
}));

export default useStyle;